import { useTailwindBreakpoints } from "components/hooks/use-tailwind-breakpoints"

import { Box } from "components/shared/box"
import { Text } from "components/shared/text"

import { AbilityGrade } from "./ability-grade"

export type AbilityInfoProps = {
  level: number
  description: string[]
  powerForNextLevel?: number
  unlocked: boolean
  title: string
  isShip: boolean
}

export function AbilityInfo({ description, powerForNextLevel = 0, level, unlocked, title, isShip }: AbilityInfoProps) {
  const { isMobile } = useTailwindBreakpoints()
  return (
    <Box className="w-full">
      <Box row className="justify-between items-center">
        <Text weight="bold" size={isMobile ? "base" : "table"} className="uppercase">
          {title}
        </Text>
        {isMobile && unlocked && <AbilityGrade level={level} />}
      </Box>
      <Box className="flex-1">
        {description.map((descriptionItem, i) => (
          <Text key={i} className="mt-3">
            {descriptionItem}
          </Text>
        ))}
      </Box>
      {!!powerForNextLevel && (
        <Text className="opacity-60 italic text-right text-[#9188E2] lg:mt-3" weight="regular">{`${powerForNextLevel} ${
          isShip ? "ship" : "bot"
        } power for level ${level + 1}`}</Text>
      )}
    </Box>
  )
}
